import React from 'react';
import { connect } from 'react-redux';
import fields from '@/constants/fields';
import VocabularyLinkInput from '../components/VocabularyLinkInput';
import VocabularyLinkValueContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/VocabularyLinkValueContainer';
import { vocabularyFieldLengths } from '../constants';

const VocabularyLinkTarget = ({
  target,
  linkUUID,
  exists,
  canRead,
  updateProperties,
  updateErrors,
}) => {
  const updateLinkTarget = (value) => (
    updateProperties(linkUUID, { target: value })
  );

  const error = updateErrors.find((e) => (
    e.context.linkUUID === linkUUID && e.fields.includes(fields.TARGET)));

  return (
    <VocabularyLinkValueContainer exists={exists} canRead={canRead}>
      <VocabularyLinkInput
        error={error !== undefined}
        fluid
        type="target"
        text={target}
        onChange={updateLinkTarget}
        maxLength={vocabularyFieldLengths.target}
      />
    </VocabularyLinkValueContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyLinkTarget);
